import { connect } from 'react-redux';
import { leaveAnnotationMode } from '../actionCreators';
import ExitAnnotationMode from '../components/ExitAnnotationMode';
function mapDispatchToProps(dispatch) {
    return {
        onClick: function () {
            dispatch(leaveAnnotationMode());
        },
    };
}
export default connect(null, mapDispatchToProps)(ExitAnnotationMode);
